<div class="tab-nav-swiper" (swipeleft)="change('next')" (swiperight)="change('prev')">
  <ng-content></ng-content>
</div>
